import { render, staticRenderFns } from "./sale-msg.vue?vue&type=template&id=35de553b&scoped=true&"
import script from "./sale-msg.vue?vue&type=script&lang=js&"
export * from "./sale-msg.vue?vue&type=script&lang=js&"
import style0 from "./sale-msg.vue?vue&type=style&index=0&id=35de553b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de553b",
  null
  
)

export default component.exports